import { useMemo } from 'react';

const toNumber = (value) => {
  if (value == null || isNaN(Number(value))) {
    return 0;
  }

  return Number(value);
};

const toCents = (value) => Math.round(toNumber(value) * 100);

const hasVariance = (approvedAmount, caHudApprovedAmount) => {
  if (caHudApprovedAmount == null) {
    return false;
  }

  return toCents(approvedAmount) !== toCents(caHudApprovedAmount);
};

const useVoucherVarianceFlags = ({
  voucherStats,
  effectiveSubmissionStatus,
}) => {
  const bucketVarianceFlags = useMemo(() => {
    return {
      regularAssistance: hasVariance(
        voucherStats?.regularAssistance?.approvedAmount,
        voucherStats?.regularAssistance?.caHudApprovedAmount,
      ),
      adjustments: hasVariance(
        voucherStats?.adjustments?.approvedAmount,
        voucherStats?.adjustments?.caHudApprovedAmount,
      ),
      specialClaims: hasVariance(
        voucherStats?.specialClaims?.approvedAmount,
        voucherStats?.specialClaims?.caHudApprovedAmount,
      ),
      repaymentAgreements: hasVariance(
        voucherStats?.repaymentAgreements?.approvedAmount,
        voucherStats?.repaymentAgreements?.caHudApprovedAmount,
      ),
      miscellaneousAccounting: hasVariance(
        voucherStats?.miscellaneousAccounting?.approvedAmount,
        voucherStats?.miscellaneousAccounting?.caHudApprovedAmount,
      ),
    };
  }, [voucherStats]);

  const hasAnyVariance = useMemo(() => {
    return Object.values(bucketVarianceFlags).some(Boolean);
  }, [bucketVarianceFlags]);

  const hasVarianceWarning =
    Boolean(voucherStats) &&
    effectiveSubmissionStatus === 'Submitted' &&
    hasAnyVariance;

  return {
    bucketVarianceFlags,
    hasVarianceWarning,
  };
};

export default useVoucherVarianceFlags;
